module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Post.a3a7f040.svg";